module.exports = __webpack_public_path__ + "img/19.ff17a09c.jpg";